module.exports = __webpack_public_path__ + "img/sparkle-4.2c032393.svg";